// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7205":"css/admin-app.6745","8934":"css/app.6745"}[chunkId] + ".css";
};